import React from 'react'
import { isFlagOn } from 'utils/featureFlags'
import {
  CourseManagerGetter,
  CourseManagerType,
} from 'layers/content/v2/Hocs/CourseManagerGetter'
import { CurriculumCourseManagerGetter } from 'layers/content/v3/Hocs/CurriculumCourseManagerGetter'
import { CURRICULUM_CONTENT_FLAG } from 'layers/content/v2/Hocs/FlaggedRouteContentGetter'

export { CourseManagerType, CURRICULUM_CONTENT_FLAG }

/**
 * Flag-switched HOC factory. Returns a component that checks the flag at
 * render time, delegating to v3 `CurriculumCourseManagerGetter` when on or
 * the original v2 `CourseManagerGetter` when off.
 *
 * Drop-in replacement for `CourseManagerGetter` — same signature.
 *
 * Reuses the same flag as the route/content fetching change
 * (`feature_LEARN-26260-curriculum-content`) so course + content flip
 * together when the flag is enabled.
 */
export function FlaggedCourseManagerGetter(Component, options) {
  const CurriculumWrapped = CurriculumCourseManagerGetter(Component, options)
  const LegacyWrapped = CourseManagerGetter(Component, options)

  function FlaggedComponent(props) {
    if (isFlagOn([CURRICULUM_CONTENT_FLAG])) {
      return <CurriculumWrapped {...props} />
    }
    return <LegacyWrapped {...props} />
  }

  FlaggedComponent.displayName = `FlaggedCourseManagerGetter(${Component.displayName ||
    Component.name ||
    'Component'})`

  return FlaggedComponent
}
